export default "__VITE_ASSET__DnSJHJl0__"